import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import loadingIcon from 'assets/images/loading.gif';
import Text from 'components/atoms/Text';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getCampaignsAction } from 'store/system';

const MainLayoutProgram: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const { campaignData } = useAppSelector((state) => state.system);

  useEffect(() => {
    dispatch(getCampaignsAction())
      .unwrap()
      .finally(() => setIsLoading(false));
  }, [dispatch]);

  if (isLoading) {
    return (
      <main className="t-mainLayout t-mainLayoutProgram">
        <div style={{
          width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
        >
          <img src={loadingIcon} width={60} alt="loading" />
        </div>
      </main>
    );
  }

  if (!campaignData) {
    return (
      <main className="t-mainLayout t-mainLayoutProgram">
        <div style={{
          width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
        >
          <Text className="t-mainLayoutProgram_notProgram" modifiers={['white', '48x68', 'center']}>
            CHƯA CÓ CHƯƠNG TRÌNH DIỄN RA
          </Text>
        </div>
      </main>
    );
  }

  return <Outlet />;
};

export default MainLayoutProgram;
